/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/ButtonCustom/index.tsx
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import { CSSProperties } from "styled-components";
import { Button } from "./styled";
import { Spin } from "antd";

//PROPS
interface Props {
    value?: string;
    icon?: React.ReactNode;
    children?: React.ReactNode;
    onClick: Function;
    onMouseOver?: Function;
    onMouseLeave?: Function;
    type?: 'primary' | 'secondary' | 'tertiary'
    danger?: boolean;
    disabled?: boolean;
    style?: CSSProperties;
    refProp?: any,
    loading?: boolean,
    hidden?: boolean,
    title?: string;
    isCircle?: boolean;
    notReady?: boolean;
    onClickNotReady?: Function;
}

const ButtonCustom: React.FC<Props> = ({ value, icon, onClick, type, danger, children, disabled, style, refProp, loading, hidden, title, 
    isCircle, onMouseOver, onMouseLeave, notReady, onClickNotReady
 }) => {
    
    if (hidden) {
        return null
    };

    return (
        <Button 
            className="ttivos-button"
            data-type={type??'primary'}
            data-danger={danger}
            data-notready={notReady}
            onClick={notReady ? ()=>{onClickNotReady?.()} : ()=>{onClick?.()}}
            value={value}
            disabled={disabled || loading}
            style={{...style, borderRadius: isCircle ? '50%' : undefined, minWidth: isCircle ? 40 : undefined, minHeight: isCircle ? 40 : undefined}}
            type="button"
            ref={refProp}
            title={title}
            onMouseOver={()=>onMouseOver?.()}
            onMouseLeave={()=>onMouseLeave?.()}
        >
            
            {loading ? <Spin size="small" /> : <>{icon}</>}
            {children}
        </Button>
    )
};

export default ButtonCustom;